import http from './http'
import { getToken } from './auth'

const authed = () => ({ headers: { 'Authorization': 'Bearer ' + getToken() } })

// ── Public (no login) — the customer's tracking page (app/t/<token>) ────────
// Bad / expired links answer 404 / 410, never 401 (see http.js interceptor).
export async function getPublicTracking(token) {
    const { data } = await http.get(`public/track/${encodeURIComponent(token)}`)
    return data
}

// ── Office ───────────────────────────────────────────────────────────────────
// { url, issuedAt, expiresAt, revokedAt, enabled, lastViewedAt } — creates the
// link on first read when the company has tracking switched on, unless
// `peek` is set: then it only reports what exists (the job drawer's control).
export async function getJobTracking(jobId, { peek = false } = {}) {
    const { data } = await http.get(`tracking/jobs/${jobId}${peek ? '?peek=1' : ''}`, authed())
    return data
}

// Issue a new link; the previous one stops working.
export async function reissueJobTrackingLink(jobId) {
    const { data } = await http.post(`tracking/jobs/${jobId}/token`, {}, authed())
    return data
}

export async function revokeJobTrackingLink(jobId) {
    const { data } = await http.post(`tracking/jobs/${jobId}/revoke`, {}, authed())
    return data
}

// The prepared message by email — only ever called from the Send button.
export async function emailCustomerMessage(jobId, { email, message, subject }) {
    const { data } = await http.post(`tracking/jobs/${jobId}/email`, { email, message, subject }, {
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + getToken() },
    })
    return data
}
